'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIndex = exports.renamePick = exports.rename = exports.fpMove = exports.move = exports.fpCopy = undefined;

var _unset2 = require('lodash/unset');

var _unset3 = _interopRequireDefault(_unset2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _rearg2 = require('lodash/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _fromPairs2 = require('lodash/fromPairs');

var _fromPairs3 = _interopRequireDefault(_fromPairs2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _flip2 = require('lodash/flip');

var _flip3 = _interopRequireDefault(_flip2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _at2 = require('lodash/at');

var _at3 = _interopRequireDefault(_at2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

exports.copy = copy;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function copy(getKey, setKey, source, target) {
  var value = (0, _get3.default)(source, getKey);
  return value === undefined ? target : (0, _set3.default)(target, setKey, value);
}

var fpCopy = exports.fpCopy = (0, _curry3.default)((0, _rearg3.default)(copy, [3, 2, 0, 1]), 4);
var move = exports.move = (0, _curry3.default)(function (getKey, setKey, object) {
  (0, _set3.default)(object, setKey, (0, _get3.default)(object, getKey));
  (0, _unset3.default)(object, getKey);
  return object;
});
var fpMove = exports.fpMove = (0, _ary3.default)((0, _flip3.default)(move), 3);
var rename = exports.rename = (0, _curry3.default)(function (renameObj, source) {
  return (0, _reduce3.default)(renameObj, fpMove, source);
}); // key is get, value is set.

var renamePick = exports.renamePick = (0, _curry3.default)(function (renameObj, source) {
  return (0, _reduce3.default)(renameObj, fpCopy(source), {});
});

var createIndex = exports.createIndex = function createIndex(keyPath, valuePath) {
  return (0, _flow3.default)((0, _map3.default)((0, _at3.default)([keyPath, valuePath])), _fromPairs3.default);
};